// ICON HEADER component
import React from 'react'
import SubHeader from './SubHeader'


export default function IconHeader(props) {
    
    return(
        
        <div class="col-12 iconHeading">
            
            <img class={props.iconStyle} src={props.img}/>
            <h3 id={props.id} class={props.styles}>{props.title}</h3>
            
        </div>
        
    )
    
}
